export const changeForEditor = (content) => {
    if (content != null && typeof content === 'string') {
        const paragraphs = content.split(/\n\n+/);
        const formatted = paragraphs.map(p => {
            const lines = p.split(/\n/);
            const joined = lines.join('<br>');
            return `<p>${joined}</p>`;
        }).join('');
        return formatted;
    }
    else return ''
}

export const  changeForDB = (content) => {
    return content
                .replaceAll('<p><br></p>', `\n`)
                .replaceAll('</p>\n<p>', `\n\n`)
                .replaceAll('</p><p>', `\n`)
                .replaceAll('<br>', `\n`)
                .replaceAll('<p>', '')
                .replaceAll('</p>', '')
                .replace(/rel="[^"]*"/, '')
                .replace(/target="[^"]*"/, '')
                .replace(/<span[^>]*>(.*?)<\/span>/g, '');
}

export const getPlainTextLength = (content) => {
    const plainText = changeForDB(content || '');
    return plainText.replace(/\n$/, '').length;
};
